import { styled } from '@mui/material';

const SignatureImage = styled('img')(({ theme }) => ({
    width: '150px',
    height: 'fit-content',
    marginLeft: theme.spacing(2),
}));

export { SignatureImage };
